module.exports = __webpack_public_path__ + "img/britons-DE.3e887a89.png";